<template>
    <div class="container-size">
      <div class="text-center mb-10" style="margin-top:150px">
        <img src="/img/other/ic_success.png" height="300">
      </div>
      <div class="text-center font-weight-bold mt-10">
        <span style="font-size:2.0rem">{{ $t('successCorporateRegist.title') }}</span>
      </div>
      <div class="text-center mt-5 mb-10" v-html="$t('successCorporateRegist.message')"></div>
      <div class="text-center mt-5 mb-15">
        <v-btn depressed color="#000080" class="pa-5" @click="goToHomePage">
          <span class="text-capitalize white--text font-weight-bold">
            {{ $t('successCorporateRegist.button') }}
          </span>
        </v-btn>
      </div>
    </div>
  </template>

<script>
export default {
    methods: {
        goToHomePage() {
            window.location.href = '/';
        }
    }
}
</script>